import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {jsonStorage} from "@/utils/jsonStorage";

export enum ApiTag {
  auth = "auth",
  claim = "claim",
  purchase = "purchase",
  swapRate = "swapRate",
  swapDeposit = "swapdeposit",
  swapStatus = "swapStatus",
  poolStats = "poolStats",
  swapAddr = "swapAddr",
  swapData = "swapData",
  profile = "profile",
  getRefCodeAndPoints = "getRefCodeAndPoints",
}

const baseUrl = import.meta.env.VITE_API_BASE_URL || "https://api.zenexhub.com";

export const api = createApi({
  reducerPath: "api",
  endpoints: () => ({}),
  tagTypes: Object.values(ApiTag),
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      // const email = localStorage.getItem("@appkit-wallet/EMAIL");

      // if (email) headers.set("X-EMAIL-ZNX", email);

      try {
        const sessionString = localStorage.getItem("siwx-sessions") as string;
        const session = JSON.parse(sessionString) as string[];
        const currentSession = session[0];
        const sessionBase64 = btoa(JSON.stringify(currentSession));

        if (sessionBase64) {
          headers.set("X-AUTH-ZNX", sessionBase64);
        } else {
          Error("No session");
        }
      } catch (error) {
        console.warn("Problem with session: ", error || "");
      }

      const locale = jsonStorage.getItem("locale", "en");

      if (locale) headers.set("Accept-Language", locale);

      return headers;
    },
  }),
});
